import React, { useMemo, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../../_metronic/_partials/controls";
import { useImportMutationBankUIContext } from "./ImportMutationBankUIContext";
import ImportMutationBankTable from "./import-mutation-bank-table/ImportMutationBankTable";
import { ImportMutationBankFilter } from "./import-mutation-bank-filter/ImportMutationBankFilter";
import { BlockOrg, RoleChecker } from "../../../../RoleChecker";
import { ImportMutationBankCreateDialog } from "./import-mutation-bank-create-dialog/ImportMutationBankCreateDialog";
import * as XLSX from "xlsx";
import moment from "moment";

export const ImportMutationBankCard = () => {
  const importMutationImportMutationBankUIContext = useImportMutationBankUIContext();
  const importMutationImportMutationBankUIProps = useMemo(() => {
    return {
      newImportMutationBankButtonClick:
        importMutationImportMutationBankUIContext.newImportMutationBankButtonClick,
    };
  }, [importMutationImportMutationBankUIContext]);

  return (
    <>
      <Card>
        <CardHeader title="Mutasi Donasi">
          <CardHeaderToolbar>
            {/* <button
              type="button"
              className="btn btn-warning mr-2"
              onClick={changeShow}
              aria-controls="collapse-filter-donasi"
              aria-expanded={open}
            >
              Cari
            </button> */}
            {BlockOrg() && (
              <button
                type="button"
                className="btn btn-primary"
                onClick={
                  importMutationImportMutationBankUIProps.newImportMutationBankButtonClick
                }
              >
                Import Mutasi Bank
              </button>
            )}
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <ImportMutationBankTable />
        </CardBody>
      </Card>
    </>
  );
};
